const items = [
  "Laser Engraving",
  "UV Printing",
  "UV DTF Transfers",
  "Personalised Gifts",
  "Corporate Awards",
  "Marked for Life",
];

const Marquee = () => (
  <div className="border-y border-zinc-900 py-8 overflow-hidden bg-[#070707]" data-testid="editorial-marquee">
    <div className="marquee-track items-baseline">
      {[0, 1].map((n) => (
        <div key={n} className="flex items-baseline shrink-0">
          {items.map((t, i) => (
            <span key={`${n}-${i}`} className="flex items-baseline">
              <span className="font-serif-display text-3xl md:text-4xl font-light italic text-zinc-500 whitespace-nowrap px-8">
                {t}
              </span>
              <span className="text-[#C87455] text-xl px-8">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
